<template>
  <div v-if="loading" class="text-center" style="margin-top: 10em">
    <div class="lds-roller">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
  <div v-else>
    <transition appear name="slide-fade">
      <div class="row">
        <div class="col-lg-12">
          <div class="mb-3">
            <router-link to="/panel_aliados" class="text-muted">
              <i class="bx bx-chevron-left"></i> Regresar
            </router-link>
          </div>
        </div>
        <div class="col-md-6 offset-md-3">
          <div class="card mb-3">
            <div class="card-header">
              <h5 class="card-title mb-0">Aliado</h5>
            </div>
            <div class="card-body text-center">
              <img
                src="assets/img/shop.png"
                alt="Aliado"
                class="img-fluid rounded-circle mb-2"
              />

              <h4 class="mb-0 fw-bold text-orange">
                {{ aliado.nombre_aliado }}
              </h4>
              <div class="mt-3">
                <span v-if="aliado.estado_aliado == 0" class="badge bg-primary"
                  >Interesado</span
                >
                <span v-if="aliado.estado_aliado == 1" class="badge bg-danger"
                  >Pendiente</span
                >
                <span v-if="aliado.estado_aliado == 2" class="badge bg-success"
                  >Completa</span
                >
                <span v-if="aliado.estado_aliado == 3" class="badge bg-warning"
                  >Exitosa</span
                >
              </div>
            </div>
            <hr class="my-0" />
            <div class="card-body">
              <div class="d-grid gap-2">
                <router-link
                  v-bind:to="'/aliado/ficha/' + id_aliado"
                  class="btn btn-outline-primary btn-lg rounded-pill"
                >
                  Ficha
                </router-link>
                <router-link
                  v-bind:to="'/aliado/info_basica/' + id_aliado"
                  class="btn btn-outline-primary btn-lg rounded-pill"
                >
                  Información básica
                </router-link>
                <router-link
                  v-bind:to="'/aliado/info_secundaria/' + id_aliado"
                  class="btn btn-outline-primary btn-lg rounded-pill"
                >
                  Información secundaria
                </router-link>
                <router-link
                  v-bind:to="'/aliado/anexos/' + id_aliado"
                  class="btn btn-outline-primary btn-lg rounded-pill"
                >
                  Anexos
                </router-link>
                <router-link
                  v-bind:to="'/aliado/solicitudes/' + id_aliado"
                  class="btn btn-outline-primary btn-lg rounded-pill"
                >
                  Solicitudes diseños
                </router-link>

                <button
                  v-on:click="generar_contrato"
                  class="btn btn-outline-primary btn-lg rounded-pill"
                >
                  Contrato
                </button>
                <router-link
                  v-bind:to="'/aliado/beneficios/' + id_aliado"
                  class="btn btn-outline-primary btn-lg rounded-pill"
                >
                  Beneficios
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "Aliado",
  metaInfo: {
    title: "Aliados - Reddy Backoffice",
  },
  data() {
    return {
      loading: true,
      id_aliado: null,
      aliado: [],
    };
  },
  props: {
    session: Object,
  },
  created: function () {
    this.id_aliado = this.$route.params.id_aliado;
    this.get_aliado();
  },
  methods: {
    get_aliado: function () {
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
      };
      axios
        .get(this.$base_url + "aliados/aliado/" + this.id_aliado, config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.aliado = response.data.data;
          this.loading = false;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    generar_contrato() {
      window.open(
        this.$base_url + "download/contrato/" + this.id_aliado,
        "_blank"
      );
    },
  },
  mounted: function () {},
};
</script>